import type { ContentType, Platform, SortOption } from '../../types/api';

/**
 * Rótulos em português dos valores de resultado.
 *
 * Ficam centralizados porque três telas precisam dos mesmos textos — o cartão,
 * a barra de filtros e o diálogo de exportação, que declara o recorte antes de
 * confirmar (RF-EU02). Rótulo duplicado é rótulo que diverge.
 */

export const PLATFORM_LABEL: Record<Platform, string> = {
  instagram: 'Instagram',
  facebook: 'Facebook',
};

export const CONTENT_TYPE_LABEL: Record<ContentType, string> = {
  post: 'Publicação',
  reel: 'Reel',
  video: 'Vídeo',
  photo: 'Foto',
  story: 'Story',
  comment: 'Comentário',
  page_post: 'Post de página',
  unknown: 'Não identificado',
};

export const SORT_LABEL: Record<SortOption, string> = {
  relevance: 'Mais relevante',
  recent: 'Mais recente',
  engagement: 'Mais engajamento',
};

/** Tipos oferecidos como filtro — subconjunto do que a normalização produz. */
export const FILTERABLE_CONTENT_TYPES: readonly ContentType[] = [
  'post',
  'reel',
  'video',
  'photo',
  'page_post',
];
